import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-forest px-5" data-testid="admin-login-page">
      <div className="w-full max-w-sm bg-cream rounded-2xl p-8 shadow-2xl">
        <div className="text-center mb-6">
          <img src="/brand/logo-transparent.png" alt="Leaf Alchemy" className="h-16 mx-auto object-contain" />
          <h1 className="font-display text-2xl text-forest mt-3">Admin Panel</h1>
          <p className="text-sm text-muted-foreground">Sign in to manage Leaf Alchemy</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label className="text-forest">Email</Label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" placeholder="admin@leafalchemy.com" className="border-forest/15 focus-visible:ring-gold" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-forest">Password</Label>
            <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" placeholder="••••••••" className="border-forest/15 focus-visible:ring-gold" />
          </div>
          {err && <p className="text-sm text-red-600" data-testid="admin-login-error">{err}</p>}
          <Button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full rounded-full bg-forest hover:bg-olive text-cream h-11 transition-colors">
            {loading ? <Loader2 className="animate-spin" size={18} /> : <><Lock size={16} className="mr-2" /> Sign In</>}
          </Button>
        </form>
      </div>
    </div>
  );
}
